import { tWithKeyAttr as t } from "../../i18nHelper";
import {
  getDeviceConfigHeadlineParts,
  getDeviceConfigSummary,
} from "../../utils/deviceConfiguration";
import {
  PROTOCOL_FREQUENCY_OPTIONS,
  TreatmentProtocol,
} from "../../services/types/treatmentProtocol.types";

/** One-line description of what a protocol will apply, used in the list and the assign column. */
export function describeProtocol(protocol: TreatmentProtocol): string {
  if (protocol.kind === "device") return describeDeviceProtocol(protocol);
  return describeRegularProtocol(protocol);
}

function describeDeviceProtocol(protocol: TreatmentProtocol): string {
  const config = protocol.deviceConfig;
  const summary = getDeviceConfigSummary(config);
  if (!summary) return "—";

  return config?.durationMinutes
    ? `${summary} · ${config.durationMinutes} ${t("MINUTES_SHORT")}`
    : summary;
}

function describeRegularProtocol(protocol: TreatmentProtocol): string {
  const parts: string[] = [];

  if (protocol.countOfAppointments) {
    parts.push(`${protocol.countOfAppointments} ${t("SESSIONS_SHORT")}`);
  }
  if (protocol.appointmentsDurationsOpenMinutes) {
    parts.push(`${protocol.appointmentsDurationsOpenMinutes} ${t("MINUTES_SHORT")}`);
  }
  if (protocol.questionnaires.length > 0) {
    parts.push(`${protocol.questionnaires.length} ${t("QUESTIONNAIRES_SHORT")}`);
  }

  return parts.length > 0 ? parts.join(" · ") : "—";
}

/**
 * Headline-only description: for a device protocol this is the modality plus counts, never the
 * montage itself. Used where a protocol is listed rather than configured — the assign dropdown and
 * the patient page — while the appointment flow keeps the full {@link describeProtocol}.
 */
export function describeProtocolHeadline(protocol: TreatmentProtocol): string {
  if (protocol.kind !== "device") return describeRegularProtocol(protocol);

  const parts = getDeviceConfigHeadlineParts(protocol.deviceConfig);
  return parts.length > 0 ? parts.join(" · ") : "—";
}

export function frequencyTypeLabelKey(frequencyType: number): string {
  return (
    PROTOCOL_FREQUENCY_OPTIONS.find((o) => o.value === frequencyType)?.labelKey ??
    "PROTOCOL_FREQ_AFTER_EACH"
  );
}
